package org.moxultimate.topwithmox.wallpaper.data

/**
 * Cursor-based request for fetching a page of wallpapers belonging to [series].
 * Pass [lastId] = 0 to load the first page; use the last received wallpaper's id for subsequent pages.
 */
data class WallpaperSeriesRequest(
    val series: String,
    val lastId: Long = 0L,
)
